import { GET_MISSING, GET_MISSING_SUCCESS, HIDE_MESSAGE, HIDE_Missing_MESSAGE, ON_ADD_Missing, ON_ADD_Missing_Success, ON_HIDE_LOADER, ON_HIDE_Missing_LOADER, ON_SHOW_LOADER, ON_SHOW_Missing_LOADER, SHOW_MESSAGE, SHOW_Missing_MESSAGE } from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  missing: null,
  missionId: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_ADD_Missing_Success: {
      return {
        ...state,
        loader: false,
        missionId: action.payload
      }
    }
    case ON_ADD_Missing: {
      return {
        ...state,
        loader: true
      }
    }
    case SHOW_Missing_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_Missing_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    // case ON_SHOW_Missing_LOADER: {
    //   return {
    //     ...state,
    //     loader: true
    //   }
    // }
    case ON_HIDE_Missing_LOADER: {
      return {
        ...state,
        loader: false
      }
    }

    case GET_MISSING: {
      return {
        ...state,
        loader: true
      };
    }

    case GET_MISSING_SUCCESS: {
      return {
        ...state,
        loader: false,
        missing: action.payload,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false,
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }
    default:
      return state;
  }
};
